export const getTabs = (status: string, PO: string = null) => ([
    { id: 'Lines', label: 'Lines' },
    { id: 'PurchaseOrderDetails', label: 'Purchase Order Details', disabled: status?.toLowerCase() === 'x' || !PO },
    { id: 'Delivery', label: 'Delivery', disabled: status?.toLowerCase() === 'x' || !PO }
]);

export const PurchaseOrdersCalculationFields = ['OrderedQuantity', 'BackorderedQuantity', 'BuyingUnit', 'Price', 'BasePrice', 'Discount'];
export const PurchaseOrderDetailsCalculationFields = ['Supplier', 'OrderType', 'PurchaseOrderCategory', 'EarliestDueDate'];
export const PurchaseOrdersDeliveryCalculationFields = ['SiteCode', 'FreightCode', 'Warehouse'];
export const DisabledSearchLookUpDrawerTabs = ['LineDetails', 'Commit', 'PurchaseOrderLineCommitments'];
export const DisabledChangeStatus = ['LineDetails', 'Commit', 'PurchaseOrderLineCommitments', 'PurchaseOrdersDiary', 'PurchaseOrdersDiaryDetails', 'PurchaseOrdersNotepad'];
